module.exports = __webpack_public_path__ + "img/thumb_34.366840a7.jpg";